export default __webpack_public_path__ + "static/newsletter-72feb9ad488665bcd038cdb73efbea52.png";